<div class="mb-4">
    <div class="row g-3">
        <div class="col-lg-3 col-md-5 col-12">
            <app-logo (appResizeObserver)="onResize($event)" [partnersUnique]="partnersUnique" />
        </div>
        <div class="col-lg-9 col-md-7 col-12">
            <div class="row h-full g-3">
                @for (facility of partnersUnique.facilities; track facility.id) {
                    <div class="col-lg-4 col-sm-6 col-12">
                        <app-facility [style.height.px]="height$ | async" [partner]="facility" />
                    </div>
                }
            </div>
        </div>
    </div>
</div>
